import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuthProvider } from '../../contexts/AuthContext';
import PreviewAuthLoader from './PreviewAuthLoader';
import ListingPreviewPage from './ListingPreviewPage';

/**
 * Gate for /preview/:listingKey routes.
 * - With ?token → direct access (OTP-verified), no auth needed
 * - Without token → requires authentication via /me check
 */
const PreviewListingGate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  if (token) {
    return <ListingPreviewPage />;
  }

  return (
    <AuthProvider>
      <PreviewAuthLoader>
        <ListingPreviewPage />
      </PreviewAuthLoader>
    </AuthProvider>
  );
};

export default PreviewListingGate;
